import type { AxiosResponse } from 'axios';
import axios from 'axios';

import type { SamlSsoRegistrationResponse } from '../dto';
import type { SamlSsoModelInvitation } from '../model';
import { samlInvitationModelToDto } from '../mapper';

const API_ROOT = `/api/v1`;
const SAML_SSO_REGISTER = `${API_ROOT}/enterprise-sso/register-start`;

export async function startRegister(
  modelInvitation: SamlSsoModelInvitation,
): Promise<AxiosResponse<SamlSsoRegistrationResponse>> {
  const response = await axios.post(SAML_SSO_REGISTER, samlInvitationModelToDto(modelInvitation));
  return response;
}
